import { atom } from 'jotai';

import type { Order } from '../order';

export const orderAtom = atom<Order | null>(null);

export const hasGracePeriodAtom = atom((get) => {
  return !!get(orderAtom)?.gracePeriodAvailable;
});
